export const filterOptions = [
	{
		label: 'All',
		value: '',
	},
	{
		label: 'Non serviceable pin codes',
		value: 'nonServicable',
	},
	{
		label: 'ODA',
		value: 'oadOrders',
	},
	{
		label: 'Orders above 3500rs',
		value: 'greaterThan3500',
	},
	{
		label: 'Orders above 4000rs',
		value: 'greaterThan4000',
	},
	{
		label: 'Blocked customers',
		value: 'blockedCustomer',
	},
	{
		label: 'Duplicate Customers',
		value: 'duplicateCustomer',
	},
];

export const shippingServiceOptions = [
	{
		label: 'IThink',
		value: 'ithink',
	},
	{
		label: 'B2B',
		value: 'b2b',
	},
];

export const internationalShippingServiceOptions = [
	{
		label: 'IThink',
		value: 'ithink',
	},
];

export const allocationStatusMapper = {
	allocated: 'Allocated',
	prozoPending: 'Prozo Pending',
	not_allocated: 'Not Allocated',
};

export const allocationStatusReasonFilters = [
	{
		text: 'shopify sent the details of fulfillment, but no locationId',
		value: 'shopify sent the details of fulfillment, but no locationId'
	},
	{
		text: 'prozo uploadOrderDoc failure',
		value: 'prozo uploadOrderDoc failure'
	},
	{
		text: 'success',
		value: 'success'
	},
	{
		text: 'prescription not found',
		value: 'prescription not found'
	},
	{
		text: 'shopify sent the warehouse details',
		value: 'shopify sent the warehouse details'
	},
	{
		text: 'order fulfilled, but invoiceGeneration failure',
		value: 'order fulfilled, but invoiceGeneration failure'
	},
	{
		text: 'prozo allocate api success, location update pending',
		value: 'prozo allocate api success, location update pending'
	},
	{
		text: 'allocation api failure',
		value: 'allocation api failure'
	},
	{
		text: 'prozo allocation api failure',
		value: 'prozo allocation api failure'
	},
	{
		text: 'allocate api not yet called',
		value: 'allocate api not yet called'
	}
];

export const prozoPendingFilters = [
	{
		label: 'All',
		value: 'all',
	},
	{
		label: 'Flagged',
		value: 'flagged',
	},
	{
		label: 'On hold',
		value: 'onhold',
	},
	{
		label: 'B2B',
		value: 'b2b',
	},
	{
		label: 'International',
		value: 'international',
	},
	{
		label: 'Others',
		value: 'others',
	},
];

export const DOWNLOAD_ORDERS = {
	allOrders: 'download_all_orders',
	openOrders: 'download_admin_open_orders'
}

export const WAREHOUSE_MAPPER = {
	'23fafcb8-9a96-437e-86f7-ebfec0e54146': 'prozoGurgaon',
	'0395cdd7-40f9-49b6-8b60-1464c6d36555': 'prozoBhiwandi',
	'e9779b93-a6f5-483a-8607-ad188f9b790e': 'prozo',
	prozoGurgaon: '23fafcb8-9a96-437e-86f7-ebfec0e54146',
	prozoBhiwandi: '0395cdd7-40f9-49b6-8b60-1464c6d36555',
	prozo: 'e9779b93-a6f5-483a-8607-ad188f9b790e',
};

export const WAREHOUSE_FILTER_MAPPER = [
	{
		label: 'prozoGurgaon',
		value: '23fafcb8-9a96-437e-86f7-ebfec0e54146',
	},
	{
		label: 'prozoBhiwandi',
		value: '0395cdd7-40f9-49b6-8b60-1464c6d36555',
	},
];